export default "__VITE_ASSET__01959b34__"